import axios from 'axios';

// Utility function to handle API errors
export const handleApiError = (error: unknown): string => {
  if (axios.isAxiosError(error) && error.response?.data?.message) {
    return error.response.data.message as string;
  }
  
  return 'An unexpected error occurred. Please try again later.';
};